import { render, staticRenderFns } from "./OptimaSettingsEmployeeView.vue?vue&type=template&id=6cba750a&scoped=true&"
import script from "./OptimaSettingsEmployeeView.vue?vue&type=script&lang=js&"
export * from "./OptimaSettingsEmployeeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba750a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cba750a')) {
      api.createRecord('6cba750a', component.options)
    } else {
      api.reload('6cba750a', component.options)
    }
    module.hot.accept("./OptimaSettingsEmployeeView.vue?vue&type=template&id=6cba750a&scoped=true&", function () {
      api.rerender('6cba750a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/optima/OptimaSettingsEmployeeView.vue"
export default component.exports